export default "__VITE_ASSET__DfSOU6$x__"